import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const MAX_ATTEMPTS = 6;
const POLL_INTERVAL_MS = 2000;

export function useCheckoutStatus(sessionId) {
  const { clear } = useCart();
  const [state, setState] = useState("checking"); // checking | paid | failed | timeout
  const [amount, setAmount] = useState(0);
  const [downloads, setDownloads] = useState([]);
  const [giftReceipt, setGiftReceipt] = useState(false);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= MAX_ATTEMPTS) { setState("timeout"); return; }
      attempts++;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setAmount((data.amount_total || 0) / 100);
        if (data.payment_status === "paid") {
          setState("paid");
          setGiftReceipt(!!data.gift_receipt);
          localStorage.setItem("gh_has_ordered", "1");
          if (!cleared.current) { clear(); cleared.current = true; }
          api.get(`/checkout/downloads/${sessionId}`).then((r) => setDownloads(r.data.downloads || [])).catch(() => {});
          return;
        }
        if (data.status === "expired") { setState("failed"); return; }
        setTimeout(poll, POLL_INTERVAL_MS);
      } catch { setTimeout(poll, POLL_INTERVAL_MS); }
    };
    poll();
  }, [sessionId, clear]);

  return { state, amount, downloads, giftReceipt };
}
